<template>
  <div class="modal fade herunteriadenModal" id="" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog  modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <form method="POST" v-on:submit.prevent="downloadCollection">
          <div class="modal-body">
            <div class="row row-data">
              <div class="col-12 pro-style">Neues Projekt anlegen</div>
              <div class="col-lg-5 col-md-5 col-sm-5 col-2nd">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label class="form-label">Projektname *</label>
                    <div class="input-group">
                      <input class="input--style-2" type="text" v-model="form_data.title" placeholder="Neubau Musterhausen" name="name" required>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="custom-control custom-checkbox mb-3 custom-check">
                    <input type="checkbox" class="custom-control-input" id="customCheck3" name="example3">
                    <label class="custom-control-label lb-dn form-label" for="customCheck3">Als Test- / Demoprojekt anlegen</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-photo-sec row-data overflow row">
              <div class="col-lg-11 col-md-11 col-sm-11">
                <h6 class="border-bottom py-2 mb-3">Demoprojekt anlegen</h6>
                <ul class=" img-thumb-list"  v-for="img in selectedPhots">
                  <li><img height="40" width="40" class="rounded" :src="img.src" alt="img1"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer mf-1st">
            <button type="button" class="btn mode-d btn-red" data-dismiss="modal">Abbrechen</button>
            <button type="submit" class="btn btn-primary mode-s" >Projekt anlegen
            </button>
            <div class="cross-close" data-dismiss="modal">
              <img src="@/assets/images/cross.png" alt="image">
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
export default {
  name: 'HerunteriadenModal',
  props: ['selectedPhots'],
  data () {
    return {
      form_data: {
        photoids: [],
        title: '',
        includeexcel: ''
      },
      download_url: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photos/downloadselected',
      request_header: {
        apitoken: localStorage.apikey,
        deviceid: 'string',
        accept: 'application/json'
      }
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {
    downloadCollection () {
      let selection_ary = []
      this.selectedPhots.forEach(value => {
        selection_ary.push(value.id)
      })
      this.form_data.photoids = selection_ary
      axios.get(this.download_url, {
        headers: this.request_header,
        data: this.form_data,
        responseType: 'blob'
      }).then(res => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'file.zip')
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/photo/components/HerunteriadenModal.vue